export default __webpack_public_path__ + "static/media/Version (1) - Early Prop - Thumbnail.1e6c5f0b.png";